import React from 'react';
import { inject } from 'mobx-react';

import { Finder } from 'apps/finder';
import { getInitialFinderPath } from 'apps/finder/utils';
import { Modal } from 'apps/modals/views/modal';
import { modalStore } from 'apps/modals/app';

import { FinderWrapper } from 'libs/editor/styles';

@inject('routerStore')
export class FinderModal extends Modal {
  constructor(props) {
    super(props);
    modalStore.SetLarge(true);
  }

  selectFileAction = (viewerURL, filename) => {
    const {
      editorStore: { InsertPreview },
    } = this.props;
    InsertPreview(viewerURL, filename);
    modalStore.Close();
  };

  render() {
    const { routerStore } = this.props;
    const { router, route } = routerStore;

    const initialPath = getInitialFinderPath(router, route);

    return (
      <FinderWrapper>
        <Finder
          selectFileAction={this.selectFileAction}
          initialPath={initialPath}
        />
      </FinderWrapper>
    );
  }
}
